import { ReactElement } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Link } from "react-router-dom";
import { Typography as T } from "@mui/material";
import { LOGIN, adminLoginFullPath, employeeLoginFullPath } from "./paths";
import useGetMe from "../hooks/queries/useGetMe";

// This is a wrapper to protect admin routes
const AdminRoleRequired = ({
  children,
}: {
  redirectPath?: string;
  children?: ReactElement;
}) => {
  const { data, status } = useGetMe();
  if (status === "loading") return null;
  if (status === "error") return <Navigate to={`/${LOGIN}`} replace />;
  if (data && data.role !== "admin") {
    return (
      <div className="flex flex-col items-center justify-center w-100 h-screen">
        <div className="w-50">
          <>
            <T variant="lgMed">You do not have admin permissions.</T>
            <div className="mt-16">
              <T>
                If you are an admin, login in{" "}
                <Link to={adminLoginFullPath}>here.</Link>
              </T>
              <T>
                If you are an employee, login in{" "}
                <Link to={employeeLoginFullPath}>here.</Link>
              </T>
            </div>
          </>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default AdminRoleRequired;
